/** Default sort for POST /v1/workspace/agent/list */
export const AGENT_LIST_DEFAULT_SORT = {
  orderBy: 'created_at',
  orderDirection: 'DESC',
};

/**
 * Builds the request body for POST /v1/workspace/agent/list.
 *
 * @param {number} page
 * @param {number} pageSize
 * @param {string} [searchKeyword] — when non-empty, adds `search: { query, fields: ['name'] }`
 * @param {object} [filters]       — optional: `{ status?, type?, category?, createdAt? }`
 * @returns {object}
 */
export const buildAgentListBody = (page, pageSize, searchKeyword = '', filters = {}) => {
  const body = {
    page,
    pageSize,
    ...AGENT_LIST_DEFAULT_SORT,
  };

  const hasFilters = Object.values(filters).some(
    (v) => (Array.isArray(v) && v.length > 0) || (v && typeof v === 'object' && !Array.isArray(v)),
  );
  if (hasFilters) {
    body.filters = filters;
  }

  const kw = typeof searchKeyword === 'string' ? searchKeyword.trim() : '';
  if (kw) {
    body.search = { query: kw, fields: ['name'] };
  }

  return body;
};
